import { tsValidateArray, tsValidateNumber, tsValidateDynamicObject, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    codeVersion: tsValidateString(),
    dataVersion: tsValidateString(),
    pathToAdvisorArtifact: tsValidateString(),
    pathToAdvisorArtifacts: tsValidateDynamicObject({ dbKeys: tsValidateArray(tsValidateString()), priority: tsValidateNumber(), path: tsValidateString() }, tsValidateString()),
    pathToOriginalBackup: tsValidateString(),
    pathToProcessedBackup: tsValidateString(),
    pathToKnowledgeArtifact: tsValidateString(),
    pathToServiceArtifacts: tsValidateString(),
    pathToSnapshotServiceArtifacts: tsValidateString(),
    bucket: tsValidateString(),
    env: tsValidateString(),
};
const Validator_GeneratedProps = {
    _numericDataVersion: tsValidateNumber(),
};
export const DBDef_Artifact = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['_numericDataVersion'],
    versions: ['1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'artifacts',
    entityName: 'artifact',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'artifacts'
    },
    backend: {
        name: 'artifacts'
    }
};
//# sourceMappingURL=db-def.js.map